import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { flatMenu } from "../../../helper/utils";
import Page401 from "./Page401";
import { getUserSession } from "../../../helper/user";

const MiddleRouterBoundary = (props) => {
  const listPermission = useSelector((state) => state.userData.listPermission);
  const { currentMenu } = useSelector((state) => state.bizzApps);
  const location = useLocation();
  const userInfo = getUserSession();

  const isSystemAdmin = userInfo?.roles?.some(
    (item) => item.alias === "SYSTEM_ADMIN"
  );

  const hasPermission = useMemo(() => {
    if (isSystemAdmin) {
      return true;
    }
    const pagePermission = flatMenu(currentMenu)?.find(
      (item) => item.path === location.pathname
    )?.apiId;
    if (pagePermission) {
      return listPermission?.some((item) => item.id === pagePermission);
    }
    return false;
  }, [currentMenu, isSystemAdmin, listPermission, location.pathname]);

  // if (!hasPermission) {
  //   return <Page401 />;
  // }

  return <>{props.children}</>;
};

export default MiddleRouterBoundary;
